export default __webpack_public_path__ + "static/media/reputationIndex.fbac9765.png";